import {createYandexMapHelper} from "../section.cds2-spot-infrastructure/yandex-map-helper/init-yandex-map";
import {LANG, YANDEX_LANG} from "../section.cds2-spot-infrastructure/yandex-map-helper/constants";
import {YMAPS_API_KEY, DURATION} from "../section.cds2-spot-infrastructure/constants";

const initObjects = ( yandexMapHelper ) => {
	const buildObjects = [];
	
	yandexMapHelper.component.querySelectorAll( 'ul.content > li' )
		.forEach( ( item ) => {
			const latitude = item.getAttribute( 'data-object-latitude' );
			const longitude = item.getAttribute( 'data-object-longitude' );
			const title = item.getAttribute( 'data-object-title' );
			
			if ( latitude && longitude && title )
			{
				const buildObjectData = {
					latitude,
					longitude,
				};
				
				const subtitle = item.getAttribute( 'data-object-subtitle' );
				const link = item.getAttribute( 'data-object-link' );
				const image = item.getAttribute( 'data-object-image' );
				const imageCover = item.getAttribute( 'data-object-image-cover' )
				const imageCover2x = item.getAttribute( 'data-object-image-cover-2x' )
				const description = item.getAttribute( 'data-object-description' );
				
				if ( title )
				{
					buildObjectData.title = title;
				}
				
				if ( subtitle )
				{
					buildObjectData.subtitle = subtitle;
				}
				
				if ( link )
				{
					buildObjectData.link = link;
				}
				
				if ( image )
				{
					buildObjectData.image = image;
				}
				
				if ( imageCover )
				{
					buildObjectData.imageCover = imageCover;
				}
				
				if ( imageCover2x )
				{
					buildObjectData.imageCover2x = imageCover2x;
				}
				
				if ( description )
				{
					const descriptionJSON = JSON.parse( description );
					
					buildObjectData.textStrings = descriptionJSON;
				}
				
				buildObjects.push( buildObjectData );
			}
		} );
	
	const iconSize = 43;
	const placemarkManagerOptions = {
		clusterize: true,
		gridSize: 128,
		margin: 0,
		clusterDisableClickZoom: false,
		clusterIconLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
			`<div class="build-objects-cluster">
				<div class="icon">
					<span class="digit">
						$[properties.geoObjects.length]
					</span>
				</div>
				<div class="arrow"></div>
			</div>`
		),
		clusterIconShape: {
			type: `Rectangle`,
			coordinates: [
				[0, 0], [iconSize, iconSize]
			]
		},
		
		zIndex: 1,
	};
	const manager = yandexMapHelper.createObjectManager( 'objects', placemarkManagerOptions );
	
	buildObjects.forEach( ( buildObject, index ) => {
		let picture = '';
		let subtitle = '';
		let link = '';
		let description = '';
		
		if ( buildObject.imageCover )
		{
			let imageCover2x = '';
			
			if ( buildObject.imageCover2x )
			{
				imageCover2x = `srcset="${buildObject.imageCover2x} 2x"`
			}
			
			picture = (`
				<picture>
					<img src="${buildObject.imageCover}" ${imageCover2x}>
				</picture>
			`);
		}
		
		if ( buildObject.subtitle )
		{
			subtitle = (`
				<p class="subtitle">
					${buildObject.subtitle}
				</p>
			`);
		}
		
		if ( buildObject.link )
		{
			let text = 'Подробнее';
			
			if ( yandexMapHelper.lang === LANG.EN )
			{
				text = 'More details';
			}
			
			link = (`
				<a class="link" href="${buildObject.link}">${text}</a>
			`);
		}
		
		if ( buildObject.textStrings )
		{
			const blocks = ['<ul class="queues">']
			
			buildObject.textStrings.forEach( ( args ) => {
				const params = ['<li>'];
				
				if ( args[0] )
				{
					params.push( `<div class="title">${args[0]}</div>` );
				}
				
				if ( args[1] )
				{
					params.push( `<div class="state">${args[1]}</div>` );
				}
				
				params.push( '</li>' );
				
				blocks.push( params.join( '' ) );
			} );
			
			blocks.push( '</ul>' );
			
			description = blocks.join( '' );
		}
		
		const placemarkClass = 'build-object-placemark';
		const placemarkSelector = `div.${placemarkClass}`;
		const balloonClass = 'build-object-placemark-balloon-wrapper';
		
		const placemarkProps = {
			type: `Feature`,
			id: index,
			geometry: {
				type: `Point`,
				coordinates: [buildObject.latitude, buildObject.longitude],
			},
			options: {
				iconLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
					`<div class="${placemarkClass}">
						<div class="icon"></div>
						<div class="arrow"></div>
					</div>`,
					{
						build() {
							this.constructor.superclass.build.call( this );
							
							const placemark = this.getElement().querySelector( placemarkSelector );
							
							if ( placemark )
							{
								const width = placemark.offsetWidth;
								const height = placemark.offsetHeight;
								
								const shapeCoordinates = [
									[width / -2, -1 * height],
									[width / 2, 0],
								];
								
								const shapeRectangle = {
									type: `Rectangle`,
									coordinates: shapeCoordinates,
								};
								
								this.getData().options.set( `shape`, shapeRectangle );
								
								placemark.style.setProperty( `position`, `absolute` );
								placemark.style.setProperty( `left`, `${width / -2}px` );
								placemark.style.setProperty( `top`, `${-1 * height}px` );
							}
						}
					}
				),
				
				hideIconOnBalloonOpen: false,
				balloonShadow: false,
				balloonPanelMaxMapArea: 0,
				balloonAutoPanMargin: 0,
				balloonAutoPan: true,
				balloonLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
					`<div class="${balloonClass}">
						<div class="build-object-placemark-balloon">
							${picture}
							<h3>${buildObject.title}</h3>
							${subtitle}
							${description}
							${link}
						</div>
						<div class="arrow"></div>
					</div>`,
					{
						build() {
							this.constructor.superclass.build.call( this );
							
							const balloonSelector = `div.${balloonClass}`;
							const balloonWrapper = this.getElement().querySelector( balloonSelector );
							const ballonArrow = this.getElement().querySelector( `${balloonSelector} > div.arrow` );
							
							const objectId = this.getData().object.id;
							const placemark = manager.objects.overlays.getById( objectId );
							const placemarkWrapper = placemark.getElement().querySelector( placemarkSelector );
							
							if ( balloonWrapper && ballonArrow && placemarkWrapper )
							{
								const balloonWidth = balloonWrapper.offsetWidth;
								const balloonHeight = balloonWrapper.offsetHeight;
								const arrowOffset = ballonArrow.offsetLeft;
								const arrowWidth = ballonArrow.offsetWidth;
								const placemarkWrapperHeight = placemarkWrapper.offsetHeight;
								const additionalOffset = 10;
								
								const leftOffset = ( arrowOffset + arrowWidth / 2 ) * -1;
								const topOffset = -1 * ( balloonHeight + placemarkWrapperHeight + additionalOffset );
								
								const shapeCoordinates = [
									[leftOffset, topOffset],
									[(balloonWidth + leftOffset), 0],
								];
								
								const shapeRectangle = {
									type: `Rectangle`,
									coordinates: shapeCoordinates,
								};
								
								this.getData().options.set( `shape`, shapeRectangle );
								
								balloonWrapper.style.setProperty( `position`, `absolute` );
								balloonWrapper.style.setProperty( `left`, `${leftOffset}px` );
								balloonWrapper.style.setProperty( `top`, `${topOffset}px` );
							}
						},
					}
				),
				
				zIndex: 1,
			}
		};
		
		manager.add( placemarkProps );
	} );
	
	manager.events.add(
		`click`,
		( evt ) => {
			const currentObjectId = evt.get( `objectId` );
			
			if ( manager.objects.balloon.isOpen( currentObjectId ) )
			{
				manager.objects.balloon.close();
			}
		}
	);
	
	if ( manager.objects.getLength() === 1 )
	{
		const object = manager.objects.getAll()[0];
		const geometry = object && object.geometry;
		const coordinates = geometry && geometry.coordinates;
		
		if ( coordinates )
		{
			yandexMapHelper.yandexMap.setCenter( coordinates )
				.then(
					() => {
						yandexMapHelper.initCenter = yandexMapHelper.yandexMap.getCenter();
					}
				)
			
		}
	}
	else
	{
		const bounds = manager.getBounds();
		if ( bounds ) {
			yandexMapHelper.yandexMap.setBounds(
				bounds,
				{checkZoomRange: true, duration: DURATION, useMapMargin: true}
			).then(
				() => {
					yandexMapHelper.initZoom = yandexMapHelper.yandexMap.getZoom();
					yandexMapHelper.initCenter = yandexMapHelper.yandexMap.getCenter();
				}
			);
		}
	}
}

const initMap = ( yandexMapHelper ) => {
	yandexMapHelper.addZoomControls( {
		position: {
			top: 20,
			right: 20,
			bottom: `auto`,
			left: `auto`,
		}
	} );
	yandexMapHelper.setCorrectScrolling();
	
	yandexMapHelper.yandexMap.margin.addArea( {
		left: 0,
		bottom: 0,
		width: `100%`,
		height: 10,
	} );
	yandexMapHelper.yandexMap.margin.addArea( {
		top: 0,
		left: 0,
		width: `100%`,
		height: 10,
	} );
	yandexMapHelper.yandexMap.margin.addArea( {
		top: 0,
		left: 0,
		width: 5,
		height: `100%`,
	} );
	yandexMapHelper.yandexMap.margin.addArea( {
		top: 0,
		right: 0,
		width: 5,
		height: `100%`,
	} );
	
	initObjects( yandexMapHelper );
};

const initCds2MapObject = () => {
	Array.from( document.querySelectorAll( `section.cds2-map-objects` ) )
		.forEach( ( component ) => {
			const mapContainer = component.querySelector( `div.map-container` );
			
			if ( mapContainer )
			{
				const lang = mapContainer.getAttribute( 'data-map-lang' );
				let ymapsApiLang = YANDEX_LANG.RU;
				
				if ( lang === LANG.EN )
				{
					ymapsApiLang = YANDEX_LANG.EN;
				}
				
				const mapProps = {
					ymapsApiKey: YMAPS_API_KEY,
					ymapsApiLang,
					mapContainer,
					component,
					readyCallback: initMap,
				};
				
				createYandexMapHelper( mapProps );
			}
		} );
};

export {
	initCds2MapObject,
};
